<div class="two-column-backgrond" [class.first-section]="isFirstSection" [class.last-section]="isLastSection">
  <div class="two-column-backgrond__column full-column" [slideBackground]="section" (containerAspectRatioChanged)="mediaRatioUpdated($event)">
    <ng-container *ngTemplateOutlet="backgroundVideo; context: { settings: section, column: columns.SINGLE }"></ng-container>
  </div>

  @if (section.type === layoutTypes.TWO_COLUMN) {
    <div
      class="two-column-backgrond__column left-column"
      [slideBackground]="leftColumnBackground"
      [style.height.px]="leftColumnHeight"
      [style.width.px]="leftColumnWidth">
      <ng-container *ngTemplateOutlet="backgroundVideo; context: { settings: leftColumnBackground, column: columns.LEFT }"></ng-container>
    </div>
    <div
      class="two-column-backgrond__column right-column"
      [slideBackground]="rightColumnBackground"
      [style.height.px]="rightColumnHeight"
      [style.width.px]="rightColumnWidth">
      <ng-container *ngTemplateOutlet="backgroundVideo; context: { settings: rightColumnBackground, column: columns.RIGHT }"></ng-container>
    </div>
  }
</div>


<ng-template let-settings="settings" let-column="column" #backgroundVideo>
  @if (settings.enableBackground && settings?.backgroundVideo; as videoModel) {
    <lib-video
      [src]="videoModel | videoPresign | async"
      class="background-video background-video--absolute"
      [ngClass]="'position-' + (settings?.backgroundSize || backgroundSizeTypes.COVER)"
      [style.objectPosition]="(settings?.backgroundPosition?.vertical || verticalPositionTypes.TOP) + ' ' + (settings?.backgroundPosition?.horizontal || horizontalPositionTypes.LEFT)"
      [hideControls]="true"
      [loop]="true"
      [autoplay]="true"
      (mediaRatioLoaded)="mediaRatioUpdated($event, column, mediaType.VIDEO)">
    </lib-video>
  }
</ng-template>
